import React from 'react';
import { motion } from 'framer-motion';

const formatMoney = (amount, currency) =>
  new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(amount || 0);

export const RecentTransactionsWidget = ({ data }) => {
  const transactions = data?.recentTransactions || [];
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
      className="bg-white border border-slate-200 p-6 rounded-sm h-full"
      data-testid="widget-recent-transactions"
    >
      <h2 className="text-xl font-chivo font-bold text-slate-900 mb-4">Recent Transactions</h2>
      <div className="space-y-3">
        {transactions.length === 0 ? (
          <p className="text-slate-600 font-ibm text-sm" data-testid="widget-no-transactions">No transactions yet</p>
        ) : (
          transactions.map((transaction) => (
            <div
              key={transaction.id}
              data-testid={`widget-transaction-item-${transaction.id}`}
              className="flex items-center justify-between py-3 border-b border-slate-100 last:border-0"
            >
              <div>
                <p className="font-ibm font-medium text-slate-900">{transaction.description}</p>
                <p className="text-xs text-slate-600 uppercase tracking-widest font-ibm mt-1">
                  {transaction.category}
                </p>
              </div>
              <div className="text-right">
                <p
                  className={`font-ibm font-semibold tabular-nums ${
                    transaction.type === 'income' ? 'text-emerald-600' : 'text-red-600'
                  }`}
                >
                  {transaction.type === 'income' ? '+' : '-'}
                  {formatMoney(transaction.amount, transaction.currency)}
                </p>
                <p className="text-xs text-slate-600 font-ibm mt-1">
                  {new Date(transaction.date).toLocaleDateString()}
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </motion.div>
  );
};
